exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sketch[data-v-f5500554]{width:100%;height:100%;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-f5500554&scoped=true!./~/less-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/palette.vue
// module id = 74
// module chunks = 0